












































import Vue from 'vue';
import moment from 'moment';
import CustomerInfo from './CustomerInfo.vue';
import CustomerTrace from './CustomerTrace.vue';
import ScoreRecord from './ScoreRecord.vue';
import CustomerVuex from '../../../vuex/common';
import customerClient from '../../../apis';
import Customer, { Sex } from '../../../models/Customer';

export default Vue.extend({
  mixins: [CustomerVuex],
  components: {
    CustomerInfo,
    CustomerTrace,
    ScoreRecord,
  },
  data() {
    return {
      traceLabel: (h: any) => {
        return h('div', [
          h('span', '轨迹'),
          h('Badge', {
            props: {
              count: this.$data.traceTotal,
            },
          }),
        ]);
      },
      traceTotal: null,
      selectedTab: null,
      totalLoaded: false,
      avatarUrl: require('assets/img/common/avatar.png'),
    };
  },
  computed: {
    customer(): any {
      return this.customerState.currentCustomer;
    },
    sexClass(): string {
      if (this.customer.wxProps.sex === Sex.Male) {
        return 'icon-male';
      } else if (this.customer.wxProps.sex === Sex.Female) {
        return 'icon-female';
      } else {
        return '';
      }
    },
    location(): string {
      if (this.customer.wxProps.country !== '中国') {
        return this.customer.wxProps.country;
      } else {
        return [
          this.customer.wxProps.province,
          this.customer.wxProps.city,
        ].filter((s) => {
          return s && s.trim() !== '';
        }).join(',');
      }
    },
    lastInteractiveDate(): string {
      return moment(this.customer.latelyInteractiveTime).fromNow();
    },
    avatar(): string {  
      return this.customer.wxProps.headimgurl ? this.customer.wxProps.headimgurl.replace('http://', 'https://') : this.avatarUrl;
    },
  },
  methods: {
    getTraceTotal() {
      customerClient.getTraceCount({
        openid: this.customer.openid,
      }).success((r) => {
        this.traceTotal = r;
        this.totalLoaded = true;
      });
    },
    syncReadCustomer() {
      customerClient.syncReadCustomer({
        openid: this.customer.openid,
      }).success((r: any) => {
        if (r.customer) {
          this.$store.commit('UPDATE_CUSTOMER', r.customer);
        }
      });
    },
    showChatBox() {
      this.$store.commit('HIDE_CHAT');
      this.$nextTick(() => {
        this.$store.commit('SHOW_CHAT', this.customer.openid);
      });
    },
  },
  mounted() {
    if (this.customerState.detailSelectedScore) {
      this.selectedTab = 'score';
    } else {
      this.selectedTab = 'basic';
    }
    this.getTraceTotal();
    this.syncReadCustomer();
  },
});
